import React from "react";
import styled from "styled-components";
import { Head, usePage } from "@inertiajs/react";
import { GlobalStyle } from "../../constants/global-style";
import ProvideLoggedInUser from "../../providers/ProvideLoggedInUser";
import SectionErrorBoundary from "../../homes/SectionErrorBoundary";
import SertifikasiApp from "../../sertifikasi/App";
import Breadcrumbs from "../../sertifikasi/Breadcrumbs";
import CurriculumHero from "../../sertifikasi/sections/CurriculumHero";
import CurriculumLessonList from "../../sertifikasi/sections/CurriculumLessonList";
import CurriculumExam from "../../sertifikasi/sections/CurriculumExam";
import RelatedCourses from "../../sertifikasi/sections/RelatedCourses";
import { outerContainerCss } from "../../constants/styles";

export default function Curriculum() {
  const { theme = "light", curriculum = {} } = usePage().props;
  const title = curriculum.name
    ? `${curriculum.name} — ${curriculum.course?.name || "Sertifikasi"}`
    : "Modul";
  const description = (curriculum.description || title).slice(0, 160);
  const hasExam = !!curriculum.exam?.available;

  return (
    <>
      <Head>
        <title>{`${title} — Taxsam Learning Center`}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Head>
      <GlobalStyle />
      <ProvideLoggedInUser>
        <SertifikasiApp theme={theme}>
          <Breadcrumbs items={curriculum.breadcrumbs || []} />
          <SectionErrorBoundary name="CurriculumHero">
            <CurriculumHero curriculum={curriculum} />
          </SectionErrorBoundary>
          <ContentSection>
            <ContentInner $hasExam={hasExam}>
              <Main>
                <SectionErrorBoundary name="CurriculumLessonList">
                  <CurriculumLessonList
                    groups={curriculum.lessons_grouped || []}
                    courseSlug={curriculum.course?.slug}
                    curriculumSlug={curriculum.slug}
                  />
                </SectionErrorBoundary>
              </Main>
              {hasExam && (
                <Side>
                  <SectionErrorBoundary name="CurriculumExam">
                    <CurriculumExam
                      exam={curriculum.exam}
                      curriculumProgressPercent={curriculum.curriculum_progress_percent}
                    />
                  </SectionErrorBoundary>
                </Side>
              )}
            </ContentInner>
          </ContentSection>
          <SectionErrorBoundary name="CurriculumRelated">
            <RelatedCourses
              title="Modul Lainnya"
              courses={(curriculum.related_curriculums || []).map((c) => ({
                ...c,
                description: "",
              }))}
            />
          </SectionErrorBoundary>
        </SertifikasiApp>
      </ProvideLoggedInUser>
    </>
  );
}

const ContentSection = styled.section`
  background: #ffffff;
  padding: 48px 0 56px;
  [data-theme="dark"] & { background: #0f172a; }

  @media (max-width: 1023px) {
    padding: 32px 0 40px;
  }
`;

const ContentInner = styled.div`
  ${outerContainerCss}
  display: grid;
  grid-template-columns: ${({ $hasExam }) => ($hasExam ? "1.6fr 1fr" : "1fr")};
  gap: 32px;
  align-items: start;

  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

const Main = styled.div`
  display: flex; flex-direction: column; min-width: 0;
`;

const Side = styled.aside`
  display: flex; flex-direction: column;
  position: sticky;
  top: 16px;

  @media (max-width: 1023px) {
    position: static;
  }
`;
